import { Component, Input, OnChanges } from '@angular/core';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { AuthService } from 'src/app/services/auth/auth.service';

/**
 * CONSULTAS → AUDITORÍA → REVERSOS (DES-09/10/11). Las verificaciones que confirman que en la cobranza no se perdió
 * nada (la cuenta cierra, la cadena de huellas, cero reversos pendientes, ninguna línea pagada huérfana) y cada reverso
 * de un abono ya pagado que se desconcilió: quién, por qué, dónde se pagó y dónde se compensó.
 */
@Component({
  selector: 'app-liquidacion-reversos',
  templateUrl: './liquidacion-reversos.component.html'
})
export class LiquidacionReversosComponent implements OnChanges {
  @Input() desde = '';
  @Input() hasta = '';

  cargando = false;
  error = '';
  v: any = null;
  r: any = null;

  reversando: string | null = null;
  motivo = '';
  ocupado = false;
  aviso = '';

  constructor(private liq: LiquidacionService, public _auth: AuthService) { }

  get puedeReversar(): boolean { return this._auth.hasPermission('liquidacion.salud.liberar'); }

  /** DES-11: el reverso de una línea pagada cuyo abono se borró sin registro; entra en el cierre siguiente. */
  reversoHuerfana = async (x: any): Promise<void> => {
    if (this.motivo.trim().length < 5) { this.error = 'Para generar el reverso escribe el motivo (5 caracteres o más).'; return; }
    this.ocupado = true; this.error = ''; this.aviso = '';
    try {
      const r = await this.liq.reversoHuerfana(x.linea, this.motivo.trim());
      this.aviso = `Reverso de ${x.venta} registrado (${r.code}): se descuenta en la próxima liquidación de ${x.comercio}.`;
      this.reversando = null; this.motivo = '';
      await this.cargar();
    } catch (e: any) { this.error = e?.error?.msg || 'No se pudo generar el reverso.'; }
    finally { this.ocupado = false; }
  };

  ngOnChanges(): void { this.cargar(); }

  private pedido = 0;

  /** Al cambiar las fechas se piden de nuevo; una respuesta vieja que llega tarde se descarta. */
  cargar = async (): Promise<void> => {
    const n = ++this.pedido;
    this.cargando = true; this.error = '';
    try {
      const [v, r] = await Promise.all([this.liq.verificacionesCobranza(this.desde, this.hasta), this.liq.reversos(this.desde, this.hasta)]);
      if (n === this.pedido) { this.v = v; this.r = r; }
    } catch (e: any) { if (n === this.pedido) this.error = e?.error?.msg || 'No se pudieron leer las verificaciones de la cobranza.'; }
    finally { if (n === this.pedido) this.cargando = false; }
  };

  estado = (e: string): { texto: string; clase: string } =>
    e === 'APLICADO' ? { texto: 'Compensado', clase: 'kb-badge-exito' } : { texto: 'Pendiente', clase: 'kb-badge-alerta' };
}
